import {
  HubConnectionBuilder,
  HttpTransportType,
  HubConnection,
} from '@microsoft/signalr';
import Config from './config';
import { logInfo } from '../logging';

let connectionPromise: Promise<HubConnection | undefined>;

export const createSocketConnection = () => {
  connectionPromise = (async () => {
    const url = Config.getSocketUrl();
    const accessToken = await Config.getAccessToken();
    logInfo('WebSocket', 'create connection');
    if (!url) {
      throw new Error('Try to create a socket connection without url');
    }
    if (!accessToken) {
      throw new Error('Try to create a socket connection without access token');
    }

    return new HubConnectionBuilder()
      .withUrl(url, {
        accessTokenFactory: async () => (await Config.getAccessToken()) ?? '',
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect([2000, 5000, 13000, 21000, 55000])
      .build();
  })();

  return connectionPromise;
};

export const getSocketConnection = async () => await connectionPromise;
